import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import LastOrderBag from './last-order-bag'

import {
  LastOrderColumnRight,
  LastOrderColumnLeft,
  LastOrderCard,
  LastOrderCardWrapper,
  LastOrderIcon,
  LastOrderLabel,
  LastOrderWrapper,
  OrderAgainButton,
  Heading,
  HeadingContentWrapper
} from './styles'
import Translation from '#src/common/components/translation'

export const LastOrder = ({ lastOrder, onLastOrderAddedToBag }) => {
  const [mainProduct, setMainProduct] = useState()
  const [otherProductsLabel, setOtherProductsLabel] = useState()
  const [showLastOrderBag, setShowLastOrderBag] = useState(false)

  const findMainItem = lastOrder => {
    return lastOrder.reduce((accumulator, current) => {
      return accumulator.recalculatedLineItem.price.centAmount >
        current.recalculatedLineItem.price.centAmount
        ? accumulator
        : current
    })
  }

  useEffect(() => {
    if (lastOrder.length === 0) {
      return
    }
    setMainProduct(findMainItem(lastOrder))
    const noOfItems = lastOrder.reduce((acc, item) => {
      acc += item.recalculatedLineItem.quantity
      return acc
    }, 0)
    if (noOfItems > 1) {
      setOtherProductsLabel(`+ ${noOfItems - 1}`)
    }
  }, [lastOrder])

  if (lastOrder.length < 1) {
    return null
  }

  return (
    <LastOrderWrapper>
      <Heading>
        <HeadingContentWrapper>
          <LastOrderIcon className='text-current' width='2em' height='1.6em' />
          <Translation id='products.last-order.title' />
        </HeadingContentWrapper>
      </Heading>
      <LastOrderCardWrapper>
        <LastOrderCard>
          <LastOrderColumnLeft>
            <LastOrderLabel aria-hidden data-testid='main-last-order-item'>
              {mainProduct?.recalculatedLineItem.name}
            </LastOrderLabel>
            {otherProductsLabel && (
              <p className='other-products'>
                {otherProductsLabel}{' '}
                <Translation
                  id={
                    otherProductsLabel === '+ 1'
                      ? 'products.last-order.more-item'
                      : 'products.last-order.more-items'
                  }
                />
              </p>
            )}
          </LastOrderColumnLeft>
          <LastOrderColumnRight>
            <OrderAgainButton
              styleType='primary'
              data-testid='last-order-order-again-button'
              onClick={() => setShowLastOrderBag(true)}
            >
              <Translation id='products.last-order.view' />
            </OrderAgainButton>
          </LastOrderColumnRight>
        </LastOrderCard>
      </LastOrderCardWrapper>
      <LastOrderBag
        isOpen={showLastOrderBag}
        onCloseBag={() => setShowLastOrderBag(false)}
        lastOrderItems={lastOrder}
        onLastOrderAddedToBag={onLastOrderAddedToBag}
      />
    </LastOrderWrapper>
  )
}

LastOrder.propTypes = {
  lastOrder: PropTypes.arrayOf(
    PropTypes.shape({
      availability: PropTypes.object,
      recalculatedLineItem: PropTypes.object
    })
  ),
  onLastOrderAddedToBag: PropTypes.func.isRequired
}
